// extracted by mini-css-extract-plugin
module.exports = {"forumContainer":"Forums_forumContainer__3N0kk"};